import { render, staticRenderFns } from "./WidgetReadMenu.vue?vue&type=template&id=1b451140&scoped=true"
import script from "./WidgetReadMenu.vue?vue&type=script&lang=js"
export * from "./WidgetReadMenu.vue?vue&type=script&lang=js"
import style0 from "./WidgetReadMenu.vue?vue&type=style&index=0&id=1b451140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b451140",
  null
  
)

export default component.exports